import "./style.scss";

import { Table as AntdTable } from "antd";
import { AnyObject } from "antd/es/_util/type";
import type {
  TableProps as AntdTableProps,
  ColumnGroupType,
  ColumnsType,
} from "antd/es/table";
import * as React from "react";

import { Pagination } from "@/components/table/helpers/pagination";

interface TableProps<T> extends Omit<AntdTableProps<T>, "title"> {
  isLoading: boolean;
  columns: ColumnsType<T> | ColumnGroupType<T>[];
  dataSource: T[];
  rowKey: string;
  current?: number;
  pageSize?: number;
  total?: number;
  nextLink?: string;
  totalRecordCountLimitExceeded?: boolean;
  handleChange?: (page: number, pageSize: number) => void;
  handleRowSelectionChange?: (
    selectedRowKeys: React.Key[],
    selectedRows?: object[]
  ) => void;
  showPagination?: boolean
}

export const Table = <T extends AnyObject,>({
  isLoading,
  columns,
  dataSource,
  rowKey,
  current,
  pageSize,
  total,
  nextLink,
  totalRecordCountLimitExceeded,
  handleChange,
  handleRowSelectionChange,
  showPagination = true,

  ...tableProps
}: TableProps<T>) => {

  return (
    <div className="table_wrapper">
      <AntdTable
        columns={
          columns as ColumnsType<AnyObject> | ColumnGroupType<AnyObject>[]
        }
        dataSource={dataSource as AnyObject[]}
        rowKey={rowKey}
        loading={isLoading}
        {...tableProps}
        scroll={{
          x: true,
        }}
        pagination={false}
        rowSelection={
          handleRowSelectionChange
            ? {
              onChange: (selectedRowKeys, selectedRows, _info) => {
                handleRowSelectionChange(selectedRowKeys, selectedRows);
              },
            }
            : undefined
        }
      />
      {showPagination && <div className="mt-4 flex pagination flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <Pagination
          isLoading={isLoading}
          current={current}
          pageSize={pageSize}
          total={total}
          nextLink={nextLink}
          totalRecordCountLimitExceeded={totalRecordCountLimitExceeded}
          handleChange={handleChange}
        />
      </div>}
    </div>
  );
};
